import data from "../../utils/constants/data.json";
import CommonComponent from "../common-component/CommonComponent";

const ExperienceComponent = () => {
    const { experienceData } = data;

    const experienceLayout = <CommonComponent items={experienceData} />;

    return experienceLayout;
};

export default ExperienceComponent;
